import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@ibe.components/shared/shared.module';
// import { TAPBookingStepsComponent } from './booking-steps/booking-steps.tap.component';
import { BookingStepsComponent } from './booking-steps/booking-steps.component';
import { TAPCommonModule } from '@ibe.components/common/common.module';

/* REPLICATED FILES */
import { INDRABookingStepsComponent } from './booking-steps/booking-steps.indra.component';

@NgModule({
	imports: [CommonModule, TAPCommonModule, SharedModule],
	declarations: [BookingStepsComponent,
		// TAPBookingStepsComponent
		INDRABookingStepsComponent],
	exports: [INDRABookingStepsComponent] // [TAPBookingStepsComponent]
})
export class StepsModule {}
